import { takeLatest } from 'redux-saga/effects';
import { GET_REMAINING_LEAVES_USERS } from '../redux.actionTypes';
import getRemainingLeavesWorker from './getRemainingLeavesWorker';

export default function* () {
    yield takeLatest(GET_REMAINING_LEAVES_USERS, getRemainingLeavesWorker);
}